import messages from './messages';
import {
  PASSWORD_REGULAR_EXPRESSION,
} from '../../../utils/common/constants';

const passwordRegex = PASSWORD_REGULAR_EXPRESSION;

export default (values,
  { formatMessage },
) => {
  const errors = {};

  if (!values.newPassword) {
    errors.passwordError = formatMessage(messages.passwordError);
  }

  if (!values.confirmPassword) {
    errors.confirmPasswordError = formatMessage(messages.passwordError);
  }

  if (values.newPassword && !passwordRegex.test(values.newPassword)) {
    errors.passwordError = formatMessage(messages.passwordLengthError);
  }

  if (values.confirmPassword && !passwordRegex.test(values.confirmPassword)) {
    errors.confirmPasswordError = formatMessage(messages.passwordLengthError);
  }

  if (values.newPassword !== values.confirmPassword) {
    errors.confirmPasswordError = formatMessage(messages.passwordMatchError);
  }

  if (!values.verificationCode && values.verificationCode != null) {
    errors.verificationCodeError = formatMessage(messages.verificationCodeRequired);
  }

  return errors;
};
